import { EditControllerResult, useEditController, useGetMany } from 'react-admin';
import { Mapping, MappingItem } from 'types/embedded/gatewayRule';

type Props = { mapping: Mapping; onSuccess: () => void };

export function useMappingPercentEditController({ mapping, onSuccess }: Props): {
  mappingPercentEditController: EditControllerResult;
  isReady: boolean;
} {
  const controller = useEditController({
    resource: 'mappings',
    id: mapping['@id'],
    mutationOptions: { onSuccess },
    mutationMode: 'pessimistic',
  });

  const mappingItemIds = ((controller.record?.mappingItems as MappingItem[]) ?? []).map(
    (item) => item['@id'],
  );

  const { data: mappingItems = [], isPending } = useGetMany<MappingItem>(
    'mapping_items',
    { ids: mappingItemIds },
    { enabled: mappingItemIds.length > 0 },
  );

  const isReady = !controller.isPending && (mappingItemIds.length === 0 || !isPending);

  return {
    mappingPercentEditController: {
      ...controller,
      record: { mappingItems },
    } as EditControllerResult,
    isReady,
  };
}
